export default function FriedmansS() {
  // TODO
}



// WEBPACK FOOTER //
// ./src/NPairedSamples/FriedmansS.js